import React, { memo } from 'react';
import { Box, Chip, Button } from '@mui/material';

/**
 * Chip toggle filters from config.personas.
 * Mirrors QuickFilterBar.js from the credit card tool.
 */
const PersonaFilterBar = memo(({ personas, activePersonas, onToggle, onClear }) => {
  if (!personas || personas.length === 0) return null;

  const hasActive = activePersonas.length > 0;

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexWrap: 'wrap',
        mb: 2,
      }}
    >
      {personas.map((p) => {
        const isActive = activePersonas.includes(p.value);
        return (
          <Chip
            key={p.value}
            label={p.label}
            variant={isActive ? 'filled' : 'outlined'}
            onClick={() => onToggle(p.value)}
            sx={{
              fontWeight: 600,
              fontSize: '0.8rem',
              cursor: 'pointer',
              transition: 'all 0.2s ease',
              ...(isActive
                ? {
                    bgcolor: 'primary.main',
                    color: '#fff',
                    boxShadow: '0 0 8px rgba(30,58,95,0.35)',
                    '&:hover': { bgcolor: 'primary.dark' },
                  }
                : {
                    borderColor: 'divider',
                    color: 'text.secondary',
                    '&:hover': { borderColor: 'primary.main', color: 'primary.main' },
                  }),
            }}
          />
        );
      })}

      {hasActive && (
        <Button
          size="small"
          onClick={onClear}
          sx={{ textTransform: 'none', color: 'text.secondary', fontWeight: 500, fontSize: '0.875rem' }}
        >
          Limpiar filtros
        </Button>
      )}
    </Box>
  );
});

PersonaFilterBar.displayName = 'PersonaFilterBar';

export default PersonaFilterBar;
